import { RegistrationFormData, RegistrationStepProps } from "./StepModel";
import { Dispatch } from "react";
import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { registerNewUser } from "../RegistrationPageSlice";
import { ErrorMessage, Field } from "formik";
import clsx from "clsx";

export const NamesStep: React.FC<RegistrationStepProps> = ({ currentStep, formikProps }) => (
  <>
    {/* begin::Form group */}
    <div className="fv-row mb-3">
      <label className="form-label fs-6 fw-bolder" htmlFor="firstName">
        First Name
      </label>
      <Field
        className={clsx(
          "form-control bg-transparent",
          { "is-invalid": formikProps.touched.firstName && formikProps.errors.firstName },
          {
            "is-valid": formikProps.touched.firstName && !formikProps.errors.firstName,
          }
        )}
        type="text"
        name="firstName"
        autoComplete="off"
        id="firstName"
        data-test-id="registration-form__first-name-input"
      />
      <div className="fv-plugins-message-container">
        <div className="fv-help-block">
          <ErrorMessage name="firstName" key={currentStep.toString()} />
        </div>
      </div>
    </div>
    <div className="fv-row mb-10">
      <label className="form-label fs-6 fw-bolder" htmlFor="lastName">
        Last Name
      </label>
      <Field
        className={clsx(
          "form-control bg-transparent",
          { "is-invalid": formikProps.touched.lastName && formikProps.errors.lastName },
          {
            "is-valid": formikProps.touched.lastName && !formikProps.errors.lastName,
          }
        )}
        type="text"
        name="lastName"
        autoComplete="off"
        id="lastName"
        data-test-id="registration-form__last-name-input"
      />
      <div className="fv-plugins-message-container">
        <div className="fv-help-block">
          <ErrorMessage name="lastName" key={currentStep.toString()} />
        </div>
      </div>
    </div>
    {/* end::Form group */}
  </>
);

export const NamesSubmit = (
  values: RegistrationFormData,
  dispatch: Dispatch<AnyAction>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  thunkDispatch: ThunkDispatch<any, any, any>
) => {
  thunkDispatch(registerNewUser({ newClientPortalUser: values }));
};
